import React from 'react';
import Swiper from 'react-id-swiper';

class Mmume extends React.Component {
  constructor(props) {
    super(props);

    this.state = this.initialState;
  }

  get initialState() {
    return {
      isLoading: true
    };
  }

  componentDidMount() {
    this.setState({isLoading: false});
  }

  render() {
    const params = {
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      spaceBetween: 10,
      slidesPerView: 4.2,
      freeMode: true,
    }
    
    return (
      this.state.isLoading ? <div>Loading...</div> :
      <div className="theme-mmume">
        <div className="mmume__logo">
          <div className="keywords">
            <p className="mmume-title"><span>k</span>eywords</p>
            <div className="mmume-article">
              <div className="keywords__row"><p className="keywords__label">Position</p><p className="keywords__value">Senior Full-stack Engineer (Side Project)</p></div>
              <div className="keywords__row"><p className="keywords__label">Skills</p><p className="keywords__value">Ionic 2 · Firebase · AWS · Hardware Sensors</p></div>
              <div className="keywords__row"><p className="keywords__label">Focus</p><p className="keywords__value">Hybrid IoT App · IFA 2017 Berlin · Samsung Creative Square</p></div>
            </div>
          </div>
          <p className="mmume-title"><span>a</span>bstract</p>
          <div className="mmume-article content-article-paragraphs">
            <p>‘Mmume’ is the name of a virtual dust pixie that lives within a smart IoT flower pot.</p>
            <p>
              Mmume has its own storyline; Mmume has survived through air pollution and has traveled 
              a long distance to settle in the flower pot, which Mmume becomes friends with it and its plant. 
            </p>
            <p>
              This little dust helps humans to communicate with the plant. Mmume’s flower pot is for people 
              who have difficulty taking good care of their plants for a long period of time. It is designed 
              with a hydroponic cultivation method to grow plants easily.
            </p>
          </div>
          <div className="row mmume-img-box">
            <div className="col-lg-12 col-xl-6 mmume-img"></div>
            <div className="col-lg-12 col-xl-6 mmume-img-2nd"></div>
          </div>
          <div className="mmume-article content-article-paragraphs">
            <p>
              This innovative way of raising plants is fun and exciting because the application constantly 
              interacts with its users. Mmume gives users a daily quests and notification, like a mobile game, 
              in which users can develop Mmume character. As Mmume grows, users earn points to buy off-line 
              event tickets, such as flower arrangement classes.
            </p>
            <p>
              Also, Mmume represents plants’ various feelings and needs. The color of the flower pot as well as 
              Mmume simultaneously change based on its plant's real-time data, such as temperature, illumination 
              and water level, compared to optimized conditions.
            </p>
            <p>The purpose of Mmume is that users sympathize with their plants more easily and deeply.</p>
          </div>
          <div className="mmume__swiper mmume-article">
            <Swiper className="swiper" {...params}>
              <div className="slide">
                <div><img className="slide-img" src={require('./../images/mmume_01.png')} alt={'Mmume Project'} /></div>
              </div>
              <div className="slide">
                <div><img className="slide-img" src={require('./../images/mmume_02.png')} alt={'Mmume Project'} /></div>
              </div>
              <div className="slide">
                <div><img className="slide-img" src={require('./../images/mmume_03.png')} alt={'Mmume Project'} /></div>
              </div>
              <div className="slide">
                <div><img className="slide-img" src={require('./../images/mmume_04.png')} alt={'Mmume Project'} /></div>
              </div>
              <div className="slide">
                <div><img className="slide-img" src={require('./../images/mmume_05.png')} alt={'Mmume Project'} /></div>
              </div>
              <div className="slide">
                <div><img className="slide-img" src={require('./../images/mmume_06.png')} alt={'Mmume Project'} /></div>
              </div>
              <div className="slide">
                <div><img className="slide-img" src={require('./../images/mmume_07.png')} alt={'Mmume Project'} /></div>
              </div>
              <div className="slide">
                <div><img className="slide-img" src={require('./../images/mmume_08.png')} alt={'Mmume Project'} /></div>
              </div>
              <div className="slide">
                <div><img className="slide-img" src={require('./../images/mmume_09.png')} alt={'Mmume Project'} /></div>
              </div>
              <div className="slide">
                <div><img className="slide-img" src={require('./../images/mmume_10.png')} alt={'Mmume Project'} /></div>
              </div>
              <div className="slide">
                <div><img className="slide-img" src={require('./../images/mmume_11.png')} alt={'Mmume Project'} /></div>
              </div>
            </Swiper>
          </div>
        </div>
        <div>
          <p className="mmume-title"><span>e</span>xperience</p>
          <div className="mmume-article content-article-list">
            <p>• Developed a hybrid app communicating with various hardware sensors using Ionic 2</p>
            <p>• Built a database using Firebase</p>
            <p>• Implemented a scalable server on AWS</p>
            <p>• Exhibited the product at IFA 2017 in Berlin</p>
            <p>• Secured initial funding from Samsung Creative Square</p>
          </div>
        </div>
        <div>
          <p className="mmume-title"><span>p</span>roject</p>
          <div className="mmume-article content-article-list">
            <p>• Mmume V1.0 App</p>
          </div>
        </div>
        <div className="mmume-final-content">
          <p className="mmume-title"><span>a</span>chivement</p>
          <div className="row mmume-article content-article-list">
            <div className="col-12">• SAMSUNG Creative Square</div>
            <div className="col-12">• 2017 Berlin IFA</div>
          </div>
        </div>
      </div>
    );
  }
}

export default Mmume;
